"use strict";

exports.__esModule = true;
var IDs = {};

exports.default = {
  IDs: IDs,
  getData: function getData(item) {
    return item;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {
    return { tags: [] };
  },
  getKeys: function getKeys() {
    return [];
  }
};